
import pinkAlienImg from "../assets/images/shipPink_manned.png"
import greenAlienImg from "../assets/images/shipGreen_manned.png"
import blueAlienImg from "../assets/images/shipBlue_manned.png"
import yellowAlienImg from "../assets/images/shipYellow_manned.png"
import beigeAlienImg from "../assets/images/shipBeige_manned.png"


import explosion0 from "../assets/images/explosion/explosion00.png"
import explosion1 from "../assets/images/explosion/explosion01.png"
import explosion2 from "../assets/images/explosion/explosion02.png"
import explosion3 from "../assets/images/explosion/explosion03.png"
import explosion4 from "../assets/images/explosion/explosion04.png"
import explosion5 from "../assets/images/explosion/explosion05.png"
import explosion6 from "../assets/images/explosion/explosion06.png"
import explosion7 from "../assets/images/explosion/explosion07.png"

export const explosionTextures = [
    explosion0,explosion1,explosion2,
    explosion3,explosion4,explosion5,
    explosion6,explosion7
]

export const alienImages = {
    "pink": pinkAlienImg,
    "blue": blueAlienImg,
    "yellow": yellowAlienImg,
    "beige": beigeAlienImg,
    "green": greenAlienImg
    
}